import React from 'react'
import LinkButton from '../Design/LinkButton'

const Header = () => {
  return (
    <div className='header'>
      <div className='header-title white roboto ls25 fw500'>
        <p>Check2Check</p>
      </div>
      <LinkButton
        sendTo='/'
        addClass='header-log-out white roboto ls25 fw500'
        text='Log Out'
      />
    </div>
  )
}

export default Header
